import React from 'react';

const styles = {
  btn: (disabled) => ({
    width: '100%',
    padding: '14px',
    fontSize: '14px',
    fontWeight: 600,
    borderRadius: 'var(--radius-md)',
    border: 'none',
    background: disabled
      ? 'var(--surface2)'
      : 'linear-gradient(135deg, #22c55e 0%, #14b8a6 100%)',
    color: disabled ? 'var(--text-muted)' : '#081b14',
    cursor: disabled ? 'not-allowed' : 'pointer',
    transition: 'background 0.15s, transform 0.15s, opacity 0.15s, box-shadow 0.15s',
    fontFamily: 'var(--font-mono)',
    letterSpacing: '0.04em',
    marginBottom: '16px',
    boxShadow: disabled ? 'none' : '0 16px 36px rgba(22, 163, 74, 0.22)',
  }),
  hint: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
    textAlign: 'center',
    fontSize: '12px',
    color: 'var(--text-muted)',
    letterSpacing: '0.02em',
    marginTop: '4px',
  },
};

export default function ConvertButton({ disabled, converting, onClick }) {
  return (
    <>
      <button
        style={styles.btn(disabled || converting)}
        onClick={onClick}
        disabled={disabled || converting}
      >
        {converting ? 'Converting...' : 'Convert file'}
      </button>
      <div style={styles.hint}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ flexShrink: 0 }}>
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" fill="#10b981"/>
          <path d="m9 12 2 2 4-4" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span>Files are processed locally and never uploaded to any server</span>
      </div>
    </>
  );
}
